// material-ui
import { ButtonBase } from '@mui/material';

// project imports
import Logo from 'ui-component/Logo';

// ==============================|| MAIN LOGO ||============================== //
// 点击 Logo 整页回到官网首页（nginx 静态站），不要用 React Router 留在 /panel SPA 内。

const LogoSection = () => {
  return (
    <ButtonBase
      disableRipple
      component="a"
      href="/"
      sx={{ display: 'inline-flex', alignItems: 'center' }}
    >
      <Logo />
    </ButtonBase>
  );
};

export default LogoSection;
